import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = { class: "n-split-input-button__wrapper" }
const _hoisted_3 = { class: "n-split-input-button__btn-wrapper" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "error-message" }

import NButton from '../../control/button/button.vue';
import { useIdGenerator } from '@/shared/designsystem/useIdGenerator';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'n-split-input-button',
},
  __name: 'split-input-button',
  props: {
  id: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
  },
  errorMessage: {
    type: String,
  },
  helpText: {
    type: String,
  },
  hideLabel: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {



const props = __props;

const { inputId } = useIdGenerator(props.id, 'n-split-input-button_');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["n-split-input-button n-input", { 'has-error': __props.errorMessage }])
  }, [
    _createElementVNode("label", {
      for: _unref(inputId),
      class: _normalizeClass(["n-split-input-button__label", { 'sr-only': __props.hideLabel }])
    }, _toDisplayString(__props.label), 11, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "input"),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "button"),
        (!_ctx.$slots.button)
          ? (_openBlock(), _createBlock(NButton, {
              key: 0,
              icon: __props.icon,
              class: "n-split-input-button__button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('buttonClick')))
            }, null, 8, ["icon"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("span", {
      class: "help-text",
      innerHTML: __props.helpText
    }, null, 8, _hoisted_4),
    _createElementVNode("span", _hoisted_5, _toDisplayString(__props.errorMessage), 1)
  ], 2))
}
}

})